(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pikacard-brand-hub"] && !Shopify.designMode) return;
  try {
    
  if (!window.pikaHubDialogsReady) {
    window.pikaHubDialogsReady = true;
    document.addEventListener('click', function(event) {
      const opener = event.target.closest('[data-pbh-open]');
      if (opener) {
        const dialog = document.getElementById(opener.dataset.pbhOpen);
        if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
      }
      if (event.target.matches('dialog.pbh-dialog')) {
        const rect = event.target.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pikacard-live"] && !Shopify.designMode) return;
  try {
    
function createPikaSchedule() {
  'use strict';
  const timezone = 'America/New_York';
  const shows = [
    {
      id: 'angel', name: 'ANGEL', title: 'LIVE BREAKS', content: 'Live Breaks',
      days: [1, 2, 4, 5, 6, 0], byday: 'MO,TU,TH,FR,SA,SU',
      startHour: 19, endHour: 0, endDay: 1,
      dayLabel: 'MON / TUE / THU / FRI / SAT / SUN',
      timeLabel: '7:00 PM–12:00 AM ET'
    },
    {
      id: 'auction', name: 'NEW HOST', title: 'SLABS AUCTION',
      content: 'PSA / CGC / graded slabs auctions',
      days: [1, 2, 3], byday: 'MO,TU,WE', startHour: 14, endHour: 19, endDay: 0,
      dayLabel: 'MON / TUE / WED', timeLabel: '2:00 PM–7:00 PM ET'
    }
  ].map(function (show) {
    Object.freeze(show.days);
    return Object.freeze(show);
  });
  Object.freeze(shows);

  const partsFormatter = new Intl.DateTimeFormat('en-US', {
    timeZone: timezone, year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
  });
  const dateFormatter = new Intl.DateTimeFormat('en-US', {
    timeZone: timezone, month: 'short', day: 'numeric'
  });
  const weekdayFormatter = new Intl.DateTimeFormat('en-US', {
    timeZone: timezone, weekday: 'short'
  });
  const timeFormatter = new Intl.DateTimeFormat('en-US', {
    timeZone: timezone, hour: 'numeric', minute: '2-digit', hour12: true
  });

  function validDate(input) {
    const date = input === undefined ? new Date() : new Date(input);
    if (!Number.isFinite(date.getTime())) throw new TypeError('A valid date is required.');
    return date;
  }

  function parts(date) {
    const result = {};
    partsFormatter.formatToParts(date).forEach(function (part) {
      if (part.type !== 'literal') result[part.type] = Number(part.value);
    });
    return result;
  }

  function asUTC(p) {
    return Date.UTC(p.year, p.month - 1, p.day, p.hour || 0, p.minute || 0, p.second || 0);
  }

  function localToDate(p) {
    const wallTime = asUTC(p);
    let candidate = wallTime;
    for (let attempt = 0; attempt < 5; attempt += 1) {
      const correction = wallTime - asUTC(parts(new Date(candidate)));
      candidate += correction;
      if (correction === 0) return new Date(candidate);
    }
    throw new RangeError('Could not resolve the Eastern Time schedule boundary.');
  }

  function shiftDay(p, number) {
    const date = new Date(Date.UTC(p.year, p.month - 1, p.day + number));
    return {year: date.getUTCFullYear(), month: date.getUTCMonth() + 1, day: date.getUTCDate()};
  }

  function getOccurrences(now, days) {
    const date = validDate(now);
    const count = days === undefined ? 10 : days;
    if (!Number.isInteger(count) || count < 1 || count > 370) {
      throw new RangeError('days must be an integer between 1 and 370.');
    }
    const today = parts(date);
    const occurrences = [];
    for (let offset = 0; offset < count; offset += 1) {
      const localDay = shiftDay(today, offset);
      const weekday = new Date(asUTC(localDay)).getUTCDay();
      shows.forEach(function (show) {
        if (!show.days.includes(weekday)) return;
        const endDay = shiftDay(localDay, show.endDay);
        const start = localToDate(Object.assign({}, localDay, {hour: show.startHour}));
        const end = localToDate(Object.assign({}, endDay, {hour: show.endHour}));
        occurrences.push({showId: show.id, show: show, start: start, end: end});
      });
    }
    return occurrences.sort(function (a, b) { return a.start - b.start; });
  }

  function getStatus(now) {
    const date = validDate(now);
    const occurrences = getOccurrences(date);
    const active = occurrences.find(function (item) { return item.start <= date && date < item.end; }) || null;
    const next = occurrences.find(function (item) { return item.start > date; }) || null;
    return {active: active, next: next, phase: active ? 'scheduled-live' : 'next-scheduled'};
  }

  function nextFor(showId, now) {
    if (!shows.some(function (show) { return show.id === showId; })) {
      throw new RangeError('Unknown PikaCard show.');
    }
    const date = validDate(now);
    return getOccurrences(date).find(function (item) {
      return item.showId === showId && item.start > date;
    }) || null;
  }

  function formatOccurrence(occurrence) {
    if (!occurrence) return null;
    const date = dateFormatter.format(occurrence.start);
    const weekday = weekdayFormatter.format(occurrence.start);
    const time = timeFormatter.format(occurrence.start) + '–' + timeFormatter.format(occurrence.end) + ' ET';
    return {date: date, weekday: weekday, time: time, timezone: 'ET', label: weekday + ', ' + date + ' · ' + time};
  }

  function configuredURL(value) {
    if (!value || /[\r\n]/.test(String(value))) return '';
    try {
      const url = new URL(value);
      const host = url.hostname.toLowerCase();
      if (url.protocol !== 'https:' || url.username || url.password ||
          !(host === 'tiktok.com' || host.endsWith('.tiktok.com'))) return '';
      return url.href;
    } catch (error) { return ''; }
  }

  function eventTitle(show) {
    return 'PikaCard | ' + show.name + ' — ' + show.title;
  }

  function eventDescription(show, url) {
    return show.content + '.\nTikTok @Pikaflip.\n' +
      (url ? url + '\n' : 'Visit PikaCard Live for the stream link.\n') +
      'Scheduled session in Eastern Time (America/New_York). Schedule may change; this is not a verified live status.';
  }

  function pad(number) { return String(number).padStart(2, '0'); }
  function localStamp(date) {
    const p = parts(date);
    return String(p.year) + pad(p.month) + pad(p.day) + 'T' + pad(p.hour) + pad(p.minute) + pad(p.second);
  }
  function utcStamp(date) { return date.toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, ''); }

  function googleCalendar(showId, now, tiktokUrl) {
    const next = nextFor(showId, now);
    const url = configuredURL(tiktokUrl);
    const params = new URLSearchParams({
      action: 'TEMPLATE', text: eventTitle(next.show),
      dates: localStamp(next.start) + '/' + localStamp(next.end),
      ctz: timezone, recur: 'RRULE:FREQ=WEEKLY;BYDAY=' + next.show.byday,
      details: eventDescription(next.show, url), location: url || 'TikTok @Pikaflip'
    });
    return 'https://calendar.google.com/calendar/render?' + params.toString();
  }

  function escapeText(value) {
    return String(value).replace(/\\/g, '\\\\').replace(/\r\n|\r|\n/g, '\\n').replace(/;/g, '\\;').replace(/,/g, '\\,');
  }

  function foldLine(line) {
    const encoder = new TextEncoder();
    let output = '';
    let length = 0;
    for (const character of line) {
      const bytes = encoder.encode(character).length;
      if (length + bytes > 75) { output += '\r\n '; length = 1; }
      output += character;
      length += bytes;
    }
    return output;
  }

  function offsetAt(date) { return Math.round((asUTC(parts(date)) - date.getTime()) / 60000); }
  function offsetStamp(minutes) {
    const absolute = Math.abs(minutes);
    return (minutes < 0 ? '-' : '+') + pad(Math.floor(absolute / 60)) + pad(absolute % 60);
  }
  function sundayOf(year, month, ordinal) {
    const firstWeekday = new Date(Date.UTC(year, month - 1, 1)).getUTCDay();
    return 1 + (7 - firstWeekday) % 7 + (ordinal - 1) * 7;
  }
  function timezoneLines(eventStart) {
    const year = parts(eventStart).year - 1;
    const standardOffset = offsetStamp(offsetAt(new Date(Date.UTC(year, 0, 15, 12))));
    const daylightOffset = offsetStamp(offsetAt(new Date(Date.UTC(year, 6, 15, 12))));
    return [
      'BEGIN:VTIMEZONE', 'TZID:' + timezone, 'X-LIC-LOCATION:' + timezone,
      'BEGIN:DAYLIGHT',
      'DTSTART:' + year + '03' + pad(sundayOf(year, 3, 2)) + 'T020000',
      'TZOFFSETFROM:' + standardOffset, 'TZOFFSETTO:' + daylightOffset,
      'TZNAME:EDT', 'RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU', 'END:DAYLIGHT',
      'BEGIN:STANDARD',
      'DTSTART:' + year + '11' + pad(sundayOf(year, 11, 1)) + 'T020000',
      'TZOFFSETFROM:' + daylightOffset, 'TZOFFSETTO:' + standardOffset,
      'TZNAME:EST', 'RRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU', 'END:STANDARD',
      'END:VTIMEZONE'
    ];
  }

  function ics(showId, now, tiktokUrl) {
    const date = validDate(now);
    const next = nextFor(showId, date);
    const url = configuredURL(tiktokUrl);
    const lines = [
      'BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//PikaCard//Live Schedule//EN',
      'CALSCALE:GREGORIAN', 'METHOD:PUBLISH', 'X-WR-CALNAME:PikaCard Live',
      'X-WR-TIMEZONE:' + timezone
    ].concat(timezoneLines(next.start), [
      'BEGIN:VEVENT',
      'UID:pikacard-' + next.showId + '-' + localStamp(next.start) + '@schedule.pikacard',
      'DTSTAMP:' + utcStamp(date),
      'DTSTART;TZID=' + timezone + ':' + localStamp(next.start),
      'DTEND;TZID=' + timezone + ':' + localStamp(next.end),
      'RRULE:FREQ=WEEKLY;BYDAY=' + next.show.byday,
      'SUMMARY:' + escapeText(eventTitle(next.show)),
      'DESCRIPTION:' + escapeText(eventDescription(next.show, url)),
      'LOCATION:' + escapeText(url || 'TikTok @Pikaflip'),
      'STATUS:TENTATIVE', 'TRANSP:TRANSPARENT'
    ]);
    if (url) lines.push('URL:' + url);
    lines.push('BEGIN:VALARM', 'ACTION:DISPLAY', 'TRIGGER:-PT15M',
      'DESCRIPTION:' + escapeText('PikaCard ' + next.show.title + ' starts in 15 minutes.'),
      'END:VALARM', 'END:VEVENT', 'END:VCALENDAR');
    return lines.map(foldLine).join('\r\n') + '\r\n';
  }

  return Object.freeze({timezone: timezone, shows: shows, getOccurrences: getOccurrences,
    getStatus: getStatus, nextFor: nextFor, googleCalendar: googleCalendar,
    ics: ics, formatOccurrence: formatOccurrence});
}


(function () {
  'use strict';
  if (window.pikaLiveUIReady) return;
  window.pikaLiveUIReady = true;
  const instances = new WeakMap();

  function init(root) {
    if (instances.has(root)) return;
    const schedule = createPikaSchedule();
    const $ = selector => root.querySelector(selector);
    const copyNode = $('[data-pkl-config]');
    let copy = {};
    try { copy = copyNode ? JSON.parse(copyNode.textContent) : {}; } catch (error) { copy = {}; }
    const labels = Object.assign({scheduledLabel:'SCHEDULED LIVE WINDOW', nextLabel:'NEXT SCHEDULED LIVE', nextForLabel:'Next scheduled', calendarSaved:'Calendar file downloaded. Open it to save your reminders.', scheduleUnavailable:'See the weekly schedule below.'}, copy);
    const calendar = $('[data-pkl-calendar]');
    const pending = $('[data-pkl-link-dialog]');
    const select = $('[data-pkl-calendar-select]');
    let selectedShow = 'angel';
    let tiktokUrl = '';
    try {
      if (/[\r\n]/.test(root.dataset.tiktokUrl || '')) throw new Error('Invalid profile URL');
      const url = new URL(root.dataset.tiktokUrl);
      if (url.protocol === 'https:' && !url.username && !url.password && (url.hostname === 'tiktok.com' || url.hostname.endsWith('.tiktok.com'))) tiktokUrl = url.href;
    } catch (error) {}
    if (tiktokUrl) root.querySelectorAll('a[data-pkl-enter]').forEach(anchor => {
      anchor.href = tiktokUrl;
      anchor.target = '_blank';
      anchor.rel = 'noopener noreferrer';
    });
    const setText = (selector, text) => { const node = $(selector); if (node) node.textContent = text; };

    function tick() {
      try {
        const now = new Date();
        const status = schedule.getStatus(now);
        const current = status.active || status.next;
        setText('[data-pkl-status-label]', status.active ? labels.scheduledLabel : labels.nextLabel);
        setText('[data-pkl-status-title]', current.show.name + ' — ' + current.show.title);
        setText('[data-pkl-status-time]', schedule.formatOccurrence(current).label);
        root.dataset.schedulePhase = status.phase;
        root.querySelectorAll('[data-pkl-show-next]').forEach(node => {
          const upcoming = schedule.nextFor(node.dataset.pklShowNext, now);
          node.textContent = labels.nextForLabel + ': ' + schedule.formatOccurrence(upcoming).label;
        });
        if (calendar && calendar.open) refreshCalendar();
      } catch (error) {
        setText('[data-pkl-status-label]', labels.scheduleUnavailable);
      }
    }

    function refreshCalendar() {
      const now = new Date();
      if (select) selectedShow = select.value;
      const next = schedule.nextFor(selectedShow, now);
      setText('[data-pkl-calendar-next]', labels.nextForLabel + ': ' + schedule.formatOccurrence(next).label);
      const google = $('[data-pkl-google]');
      if (google) google.href = schedule.googleCalendar(selectedShow, now, tiktokUrl);
    }

    function openCalendar(showId) {
      if (!calendar) return;
      if (pending && pending.open) pending.close();
      selectedShow = showId === 'auto' ? schedule.getStatus(new Date()).next.showId : showId;
      if (select) select.value = selectedShow;
      refreshCalendar();
      setText('[data-pkl-calendar-result]', '');
      if (!calendar.open) calendar.showModal();
    }

    function onClick(event) {
      const target = event.target.closest('button, a, dialog');
      if (!target) return;
      if (target.hasAttribute('data-pkl-remind')) {
        event.preventDefault();
        openCalendar(target.dataset.pklRemind || 'auto');
      } else if (target.hasAttribute('data-pkl-enter')) {
        if (!tiktokUrl) {
          event.preventDefault();
          if (pending && !pending.open) pending.showModal();
        } else if (target.tagName !== 'A') {
          window.open(tiktokUrl, '_blank', 'noopener,noreferrer');
        }
      } else if (target.hasAttribute('data-pkl-ics')) {
        event.preventDefault();
        refreshCalendar();
        const url = URL.createObjectURL(new Blob([schedule.ics(selectedShow, new Date(), tiktokUrl)], {type:'text/calendar;charset=utf-8'}));
        const download = document.createElement('a');
        download.href = url;
        download.download = 'pikacard-' + selectedShow + '-weekly.ics';
        root.appendChild(download);
        download.click();
        download.remove();
        setTimeout(() => URL.revokeObjectURL(url), 10000);
        setText('[data-pkl-calendar-result]', labels.calendarSaved);
      } else if (target.hasAttribute('data-pkl-google')) {
        refreshCalendar();
      }
      if (event.target.matches('dialog')) {
        const rect = event.target.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
      }
    }

    root.addEventListener('click', onClick);
    if (select) select.addEventListener('change', refreshCalendar);
    const onVisibility = () => { if (!document.hidden) tick(); };
    document.addEventListener('visibilitychange', onVisibility);
    const timer = setInterval(() => { if (!document.hidden) tick(); }, 30000);
    instances.set(root, () => {
      clearInterval(timer);
      root.removeEventListener('click', onClick);
      document.removeEventListener('visibilitychange', onVisibility);
      if (select) select.removeEventListener('change', refreshCalendar);
      instances.delete(root);
    });
    tick();
  }

  function scan(scope) {
    if (scope.matches && scope.matches('[data-pika-live]')) init(scope);
    scope.querySelectorAll('[data-pika-live]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document), {once:true});
  else scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => {
    const directCleanup = instances.get(event.target);
    if (directCleanup) directCleanup();
    event.target.querySelectorAll('[data-pika-live]').forEach(root => { const cleanup = instances.get(root); if (cleanup) cleanup(); });
  });
})();


  } catch(e) { console.error(e); }
})();
})();
